import { InputText } from '@ev-tech/ui-core-components/InputText';

import { type RangeInputProps } from './RangeInput.types';
import { RangeInput } from './RangeInput';
import { useAppContext } from '../../hooks/useAppContext';

export const ConstructionYearInput = ({ 'data-testid': dataTestId, ...restProps }: RangeInputProps) => {
  const { t } = useAppContext();
  return (
    <RangeInput
      label={t('search.searchbar.advFilter.constructionYear')}
      id="constructionYear"
      inputComponent={<InputText type="number" inputMode="numeric" />}
      data-testid={dataTestId}
      {...restProps}
    />
  );
};
